import React, {useState, useEffect} from 'react'

import {
  Card, Col, Form, Row, Select
} from "antd";

import data from '../../data/rawMaterialData'

const compactItemStyle = { marginBottom: "10px" };
const compactLabelCol = { flex: '40px' };
const compactWrapperCol = { flex: 'auto' };

const LayerSelectorAdvance = (props) => {
  const {layers, gsm, bf, layerSelector} = props

  // Access the parent Form instance so we can sync field values
  const formInstance = Form.useFormInstance();

  // Initialize gsm/bf dropdown options AND sync form field values from layers
  useEffect(() => {
    if (layers && layers.length > 0 && gsm && bf) {
      let needsUpdate = false;
      const gsmArr = [...gsm];
      const bfArr = [...bf];
      const formValues = {};

      layers.forEach((layer, i) => {
        if (layer.materialType && data.materialGsm[layer.materialType] && (!gsmArr[i] || gsmArr[i].length === 0)) {
          gsmArr[i] = data.materialGsm[layer.materialType];
          bfArr[i] = data.materialBf[layer.materialType] || [];
          needsUpdate = true;
        }
        // Sync form field values from the layers state
        if (layer.materialType) formValues[`materialType-${i}`] = layer.materialType;
        if (layer.gsm) formValues[`materialGsm-${i}`] = layer.gsm;
        if (layer.bf) formValues[`materialBf-${i}`] = layer.bf;
        if (layer.ff) formValues[`materialFf-${i}`] = layer.ff;
      });

      if (needsUpdate) {
        props.setGsm(gsmArr);
        props.setBf(bfArr);
      }

      // Update the parent form so Selects reflect the preserved values
      if (formInstance && Object.keys(formValues).length > 0) {
        formInstance.setFieldsValue(formValues);
      }
    }
  }, [layers]);

  const handleLayerChange = (layerId, field, val) => {
    const layersArray = layers.map(l => ({...l}))
    const gsmArray = [...gsm]
    const bfArray = [...bf]
    layersArray[layerId-1][field] = val
    if(field === 'materialType'){
      gsmArray[layerId-1] = data.materialGsm[layersArray[layerId-1].materialType] || []
      bfArray[layerId-1] = data.materialBf[layersArray[layerId-1].materialType] || []
      props.setGsm([...gsmArray])
      props.setBf([...bfArray])
    }
    props.setLayers([...layersArray])
  }

  return (
    <>
      {layerSelector ? (
        <Card>
          {layers.map((layer, i) => {
            const layerLabel = layer.layerType.charAt(0).toUpperCase() + layer.layerType.slice(1);
            const isFlute = layer.layerType === 'flute';
            const colSpan = isFlute ? 6 : 8;
            return (
              <React.Fragment key={`layer-${i}`}>
                <div style={{ fontWeight: 600, marginBottom: 4 }}>{layerLabel} Layer:</div>
                <Row gutter={12}>
                  <Col xs={colSpan} md={colSpan}>
                    <Form.Item style={compactItemStyle} name={`materialType-${i}`} label="Type" labelCol={compactLabelCol} wrapperCol={compactWrapperCol} rules={[{ required: true, message: "Select type!" }]}>
                      <Select name={`materialType-${i}`} loading={!data} showSearch placeholder="Type" optionFilterProp="children" filterOption={(input, option) => option.children.includes(input)} filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())} onChange={(val) => handleLayerChange(layer.layerId, 'materialType', val)}>
                        {data && data.materialType.map((type, idx) => (<Select.Option key={idx+1} value={type}>{type}</Select.Option>))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={colSpan} md={colSpan}>
                    <Form.Item style={compactItemStyle} name={`materialGsm-${i}`} label="Gsm" labelCol={compactLabelCol} wrapperCol={compactWrapperCol} rules={[{ required: true, message: "Select GSM!" }]}>
                      <Select name={`materialGsm-${i}`} loading={!data} showSearch placeholder="GSM" optionFilterProp="children" filterOption={(input, option) => option.children.includes(input)} onChange={(val) => handleLayerChange(layer.layerId, 'gsm', val)}>
                        {gsm[i].map((g, idx) => (<Select.Option key={idx+1} value={g}>{g}</Select.Option>))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={colSpan} md={colSpan}>
                    <Form.Item style={compactItemStyle} name={`materialBf-${i}`} label="Bf" labelCol={compactLabelCol} wrapperCol={compactWrapperCol} rules={[{ required: true, message: "Select BF!" }]}>
                      <Select name={`materialBf-${i}`} loading={!data} showSearch placeholder="BF" optionFilterProp="children" filterOption={(input, option) => option.children.includes(input)} onChange={(val) => handleLayerChange(layer.layerId, 'bf', val)}>
                        {bf[i].map((b, idx) => (<Select.Option key={idx+1} value={b}>{b}</Select.Option>))}
                      </Select>
                    </Form.Item>
                  </Col>
                  {isFlute && (
                    <Col xs={6} md={6}>
                      <Form.Item style={compactItemStyle} name={`materialFf-${i}`} label="Ff" labelCol={compactLabelCol} wrapperCol={compactWrapperCol} rules={[{ required: true, message: "Select FF!" }]}>
                        <Select name={`materialFf-${i}`} loading={!data} showSearch placeholder="FF" optionFilterProp="children" filterOption={(input, option) => option.children.includes(input)} onChange={(val) => handleLayerChange(layer.layerId, 'ff', val)}>
                          {data && data.ff.map((ff, idx) => (<Select.Option key={idx+1} value={ff}>{ff}</Select.Option>))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              </React.Fragment>
            );
          })}
        </Card>
      ) : <></>}
    </>
  )
}

export default LayerSelectorAdvance
